export default __webpack_public_path__ + "media/scenarioC-step1.png";